import React, { useEffect } from "react";
import { Alert } from "react-bootstrap";
import "../../assets/styles/PopupMessage.css";

const PopupMessage = ({ type = "success", message = "", onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onClose) onClose();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  // تحديد نوع الـ Alert بناءً على النوع
  const getVariant = () => {
    switch (type) {
      case "success":
        return "success";
      case "error":
        return "danger";
      case "info":
        return "info";
      case "warning":
        return "warning";
      default:
        return "primary";
    }
  };

  return (
    <div className="popup-message-container d-flex justify-content-center">
      <Alert
        variant={getVariant()}
        className={`popup-message-box text-center shadow ${type}`}
      >
        {message}
      </Alert>
    </div>
  );
};

export default PopupMessage;
